import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Emergency01Component } from "../../shared/components/top-bar/request-assistance-01/emergency01.component";
import { FooterComponent } from '../../shared/components/footer/footer.component';

@Component({
  selector: 'app-assistance-layout',
  imports: [Emergency01Component,FooterComponent, RouterOutlet],
  templateUrl: './assistance-layout.component.html',
  styleUrl: './assistance-layout.component.scss'
})
export class AssistanceLayoutComponent {

}
